import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyPProps } from "../types";

function TypographyP({ as, asChild, className, ...props }: TypographyPProps) {
  const Component = resolveElement(asChild, as, "p");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.P] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          ~leading-6/9
          ~text-base/2xl
          font-body
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyP;
